import { StyleSheet } from 'react-native';

import { Fonts } from 'assets/fonts';

import { COLOR } from 'utils/colors';

const styles = StyleSheet.create({
    container: {
        flex: 1,
        height: 52,
        justifyContent: 'center',
    },
    title: {
        marginLeft: 16,
        color: COLOR.WHITE_OVERLAY(0.7),
        fontFamily: Fonts.main.regular,
        fontSize: 16,
    },
    selectedTitle: {
        color: COLOR.background,
        fontFamily: Fonts.main.bold,
        fontSize: 16,
    },
    checkMark: {
        position: 'absolute',
        right: 20,
        alignSelf: 'center',
    },
});

export default styles;
